import { Environment } from '../environment';
import { normalizeOrigins } from '../utils/misc';
const BASE_URL = 'bowtie.com.hk';
export const MARKETING_SITE_ORIGIN = function () {
  if (process.env.REACT_APP_ENVIRONMENT === 'local' || process.env.REACT_APP_ENVIRONMENT === 'pull-request' || process.env.REACT_APP_ENVIRONMENT === 'development') {
    return `https://dev.${BASE_URL}`;
  } else if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
    return `https://staging.${BASE_URL}`;
  } else {
    return `https://www.${BASE_URL}`;
  }
}();
export const EMBED_ORIGIN = function () {
  if (process.env.REACT_APP_ENVIRONMENT === Environment.Local || process.env.REACT_APP_ENVIRONMENT === Environment.PullRequest) {
    return window.location.origin;
  } else {
    return MARKETING_SITE_ORIGIN;
  }
}();
export const ALLOWED_PARENT_ORIGINS = function (_process$env$REACT_AP) {
  const configured = normalizeOrigins(((_process$env$REACT_AP = process.env.REACT_APP_MARKETING_SITE_ORIGIN) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : '').split(',').map(origin => origin.trim()).filter(Boolean));
  return configured.length > 0 ? configured : [EMBED_ORIGIN];
}();